import React, { ComponentType, VFC } from 'react';
import { Route, RouteComponentProps, RouteProps } from 'react-router-dom';
import BaseLayout from '../Layouts/BaseLayout';
import AuthRequired from '~/src/usersite/components/Auth/AuthRequired';

interface Props extends RouteProps {
  component: ComponentType<RouteComponentProps<any>> | ComponentType<any>;
  displayFooter?: boolean;
}
const AuthRequiredBaseLayoutRoute: VFC<Props> = ({
  component: Component,
  displayFooter = true,
  ...rest
}: Props) => {
  return (
    <Route
      {...rest}
      render={(matchedProps) => (
        <AuthRequired>
          <BaseLayout displayFooter={displayFooter}>
            <Component {...matchedProps} />
          </BaseLayout>
        </AuthRequired>
      )}
    />
  );
};

export default AuthRequiredBaseLayoutRoute;
